/**
 * @packageDocumentation
 * @module f1/data
 */

import { TParseFormatOptions, IParseFormatRule } from '../types';

type TValue = string | object;

const splitNewline = /\n/;

export class PfTextList implements IParseFormatRule<TValue> {
  format(options: TParseFormatOptions, value: TValue) {
    if (value == null) {
      return '';
    }

    try {
      value = typeof value === 'string' ? JSON.parse(value) : value;
      return Array.isArray(value) ? value.join('\n') : value + '';
    } catch (e) {
      return value + '';
    }
  }

  parse(options: TParseFormatOptions, value: string): TValue {
    const valueArray = !Array.isArray(value) ? (value + '').split(splitNewline) : (value as string[]);
    return valueArray.map((v) => {
      return typeof v === 'string' ? v.trim() : v;
    });
  }

  defaults() {
    return {};
  }
}

export default new PfTextList();
